import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatSnackBar } from '@angular/material';

import { AuthService } from '@auth/auth.service';
import { REQUEST_TYPE } from '@utils';

interface IReset {
  password: string;
  confirm: string;
  token: string;
}

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.sass']
})
export class ResetPasswordComponent implements OnInit {
  reset: IReset;
  showSpinner: Boolean = false;
  public title = 'Restablecer Contraseña';

  constructor(
    private router: Router,
    private authService: AuthService,
    public snackBar: MatSnackBar,
    private route: ActivatedRoute,
  ) {
    this.reset = {
      password: '',
      confirm: '',
      token: '',
    };
  }

  ngOnInit() {
    const requestType = this.route.url['value'][0]['path'];
    this.reset.token = this.route.snapshot.paramMap.get('token');

    if (requestType === REQUEST_TYPE.ACTIVATE) {
      this.title = 'Crear Contraseña';
    }
  }

  restorePassword() {
    const password1 = this.reset['password'];
    const password2 = this.reset['confirm'];

    if (password1.trim().length && password2.trim().length) {
      if (password1 !== password2) {
        this.openSnackBar('Las contraseñas no coinciden', 'Error Password');
      } else if (password1 === password2) {
        this.showSpinner = true;
        this.authService.resetAccountPassword(this.reset).subscribe(
          response => {
            this.showSpinner = false;
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            this.openSnackBar('Contraseña actualizada', 'Info');
            this.reset = {
              password: ' ',
              confirm: ' ',
              token: ''
            };
            setTimeout(() => {
              this.router.navigate(['']);
            }, 1600);
          },
          err => {
            console.log(err);
            let strMessage: string;
            this.showSpinner = false;
            if ((err.status === 400 || err.status === 404) && err.ok === false) {
              strMessage = (typeof err.error.errors === 'string') ? err.error.errors : err.error.errors.password[0];
              this.openSnackBar(strMessage, 'Error Password');
            } else if (err.status === 0 && err.ok === false) {
              strMessage = 'No hay conexión con el servidor';
              this.openSnackBar(strMessage, 'Info');
            }
          }
        );
      }
    } else {
      this.openSnackBar('Ingrese las nuevas contraseñas', 'Info');
    }
  }

  openSnackBar(message: string, action: string): void {
    this.snackBar.open(message, action, {
      verticalPosition: 'top',
      horizontalPosition: 'right',
      duration: 4000,
    });
  }
}
